import { SelectedBaggageService } from '../types';

export const hasDeletableServices = (services?: SelectedBaggageService[]) => {
	return services?.some(service => service.count > (service.confirmedCount ?? 0)) ?? false;
};
